<div class="close-box">
    <div class="close-box-child">
        <h1>{{title}}</h1>
    </div>
</div>